import React, { createRef, useEffect, useState } from "react";

import FynbosIllustration from "images/illustrations/Fynbos_illustration.inline.svg";
import MountainIllustration from "images/illustrations/Mountain_illustration.inline.svg";

import { convertToSlug } from "../../utils/convertToSlug";
import { DesktopTabletOnly, MobileOnly } from "../base/wrapper/device";
import GeneralAccordionSetWrapper from "../shared/accordions/generalAccordionSetWrapper";
import TabsWrapper from "../shared/tabs/tabsWrapper";

const TextTabs = ({ tabsDetails }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [tabs, setTabs] = useState([]);
  useEffect(() => {
    setTabs(
      tabsDetails && tabsDetails.length
        ? tabsDetails?.map((tab, index) => {
            return {
              title: tab?.title,
              id: index,
              ref: createRef(),
              desc: tab?.desc,
              accordionSlug: convertToSlug(tab?.title),
              comp: (
                <div
                  className="pr-4 pl-3 sm:overflow-y-scroll sm:h-96 sm:gvi-scrollbar-thin masked-overview masked-overview-down bg-transparent text-black-lighter dark:text-gray-generic"
                  dangerouslySetInnerHTML={{ __html: tab?.desc || "" }}
                />
              ),
              tabState: tab?.tabState
            };
          })
        : []
    );
  }, [tabsDetails]);

  const updateNavigator = (idx) => {
    setCurrentSlide(idx);
  };

  return (
    <section className="relative flex items-center justify-center w-screen py-20 md:px-0 md:pb-36 mx-auto bg-yellow-lighter dark:gvi-dark-gray-bg">
      <MountainIllustration className="hidden md:block dark:hidden absolute -right-[12vw] top-[6vw] h-5/6 xl:w-2/5" />
      <FynbosIllustration className="hidden dark:md:block absolute -right-[8%] top-[16%] h-3/4" />
      <div className="w-11/12 md:w-9/12">
        <div className="flex flex-col w-full md:w-2/3">
          {tabs && (
            <>
              <MobileOnly>
                <GeneralAccordionSetWrapper
                  list={tabs}
                  currentSlide={currentSlide}
                  setCurrentSlide={() => {}}
                  accordionIdentifier="accordionSlug"
                  controlClassName="flex px-3 py-5 rounded-sm bg-yellow-light dark:bg-gray-darker"
                  contentClassName={`bg-white dark:gvi-dark-gray-bg tab-content tab-space dark:gvi-light-gray-text text-generic-text p-3`}
                />
              </MobileOnly>
              <DesktopTabletOnly>
                <TabsWrapper
                  tabs={tabs}
                  defaultSelectedTab={currentSlide}
                  updateSelectedTab={updateNavigator}
                  isVertical={false}
                  standalone={true}
                  additionalContentClass="h-full sm:pt-36 sm:bg-yellow-lighter sm:dark:gvi-dark-gray-bg"
                  additionalContentTabClasses="sm:h-96  md:!overflow-y-hidden"
                />
              </DesktopTabletOnly>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default TextTabs;
